import { render, staticRenderFns } from "./RequestReturnTable.vue?vue&type=template&id=4a9f249f&scoped=true"
import script from "./RequestReturnTable.vue?vue&type=script&lang=js"
export * from "./RequestReturnTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9f249f",
  null
  
)

export default component.exports